import { Navigate } from 'react-router-dom';
import { isOmegaAdmin } from '@/features/omega/adminMode';
import { Breadcrumbs } from '@/features/omega/Breadcrumbs';
import { OmegaMemoryTile } from '@/features/omega/dashboard/tiles/OmegaMemoryTile';

export function OmegaMemoryPage() {
  if (!isOmegaAdmin()) return <Navigate to="/" replace />;
  return (
    <div className="omega-shell flex flex-col gap-5 pb-8">
      <Breadcrumbs
        crumbs={[{ label: 'OMEGA', to: '/omega' }, { label: 'Memory' }]}
      />
      <h1 className="text-xl font-semibold text-ink">OMEGA Memory</h1>
      <OmegaMemoryTile />
    </div>
  );
}
